import IconWrapper, {
  IconWrapperProps,
} from "@repo/ui/src/components/IconWrapper";

const ShopLocal = (props: IconWrapperProps) => (
  <IconWrapper viewBox="0 0 24 25" width="24" height="25" {...props}>
    <path
      d="M6.10987 12.4668L11.3911 12.4892C11.4958 12.4892 11.5407 12.5341 11.5407 12.6389L11.5557 17.9154C11.5557 18.6339 11.8474 19.2252 12.4534 19.2252C13.0144 19.2252 13.3211 18.7013 13.5904 18.1175L18.9913 6.4568C19.1335 6.1649 19.2008 5.91043 19.2008 5.6859C19.2008 5.19193 18.8342 4.8252 18.333 4.8252C18.1161 4.8252 17.8543 4.89255 17.5625 5.02727L5.9079 10.4235L5.68554 10.5316C5.21095 10.7738 4.80078 11.0757 4.80078 11.5686C4.80078 12.1599 5.3693 12.4668 6.10987 12.4668Z"
      stroke="currentColor"
      strokeWidth="2"
    />
  </IconWrapper>
);

export default ShopLocal;
